import store from "@/store";
const checkIdentifier = async (_rule, value, api, id) => {
  if (!value) return Promise.reject("必填未填");
  if (/^(_|[a-z])[_a-z0-9]*$/.test(value)) {
    if (value.length >= 64) return Promise.reject("长度须大于0且小于64");
  } else return Promise.reject("编码必须由半角小写字母,数字,_组成,首字母必须是小写字母或_");
  const params = { validityValue: value, instanceId: store.state.model.instanceId };
  if (id) params.id = id;
  const res = await api(params);
  console.log(res);
  if (!res.success) {
    return Promise.reject("该编码已存在");
  }
  return Promise.resolve();
};
const checkName = async (_rule, value, api, id) => {
  if (!value) {
    return Promise.reject("必填未填");
  }
  if (value.length >= 64) {
    return Promise.reject("长度须大于0且小于64");
  }
  const params = { validityValue: value, instanceId: store.state.model.instanceId };
  if (id) params.id = id;
  const res = await api(params);
  if (!res.success) {
    return Promise.reject("该名称已存在");
  }
  return Promise.resolve();
};

export { checkIdentifier, checkName };
